import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { getProductCategories } from "../../data/products";
import ProductCardImage from "./ProductCardImage";

export default function ProductCard({ product }) {
  const categories = getProductCategories(product);
  return (
    <article className="catalog-card">
      <Link to={`/products/${product.slug}`} aria-label={`${product.name} — View Details`} aria-describedby={`card-sku-${product.slug}`}>
        <ProductCardImage images={product.images} />
        <div className="catalog-card-copy">
          <span className="catalog-card-category">{categories.map((category) => category.name).join(" · ")}</span>
          <h3>{product.name}</h3>
          <span className="product-sku" id={`card-sku-${product.slug}`}>SKU: {product.sku}</span>
          <span className="catalog-card-link">View Details <FiArrowRight aria-hidden="true" /></span>
        </div>
      </Link>
    </article>
  );
}
